import { lazy, Suspense } from 'react';
import type { IconSelectProps } from './icon-select';

// Lazy load IconSelect to split the icon list from the main bundle
const IconSelect = lazy(() => import('./icon-select'));

const IconSelectLazy = (props: IconSelectProps) => {
  return (
    <Suspense>
      <IconSelect {...props} />
    </Suspense>
  );
};

IconSelectLazy.displayName = 'IconSelectLazy';

export default IconSelectLazy;

export { getIconLabel } from './utils';
